export default "__VITE_ASSET__CKn7fGgy__"